import {
    CalculatorState,
} from '../types/mx/creditoReal/reducers';
import {BankTarget} from '../types/mx/types';
import {EMPTY_CATALOG, EMPTY_STRING} from './GlobalConstants';

export const calculatorInit: CalculatorState = {
    queryStringPrice: 0,
    queryStringDownPayment: 0,
    price: '',
    downPayment: '',
    isUrlFromPI: false,
    months: 0,
    quotas: [],
    monthlyPayment: {},
    hasInsurance: true,
    failInsurance: false,
    bank: BankTarget.CREDITO_REAL,
    brandSelected: EMPTY_CATALOG,
    modelSelected: EMPTY_CATALOG,
    versionSelected: EMPTY_CATALOG,
    yearSelected: EMPTY_CATALOG,
    provinceSelected: EMPTY_CATALOG,
    assemblyCountrySelected: EMPTY_CATALOG,
    postalCode: EMPTY_STRING
};
